/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */

package com.narbase.letsgo.router

import com.narbase.letsgo.models.roles.AdminPrivilege


abstract class Routing {
    val endPoints = mutableListOf<EndPoint<*, *>>()
    abstract fun init(): Unit
    protected fun api(block: Context.() -> Unit) {
        endPoints.clear()
        block(Context("", mutableSetOf(), mutableSetOf(), mutableSetOf()))
    }

    protected fun <V : Any, D : Any> Context.route(endPoint: EndPoint<V, D>) {
        endPoint.applyContext(this)
        addOrThrow(endPoint)
    }


    protected fun <V : Any, D : Any> Context.crud(endPoint: CrudEndPoint<V, D>) {
        "list" { route(endPoint.listEndpoint) }
        "add" { route(endPoint.addEndpoint) }
        "update" { route(endPoint.updateEndpoint) }
        "delete" { route(endPoint.deleteEndpoint) }
    }

    private fun addOrThrow(endPoint: EndPoint<*, *>) {
        endPoint.markAsRegistered()
       /* if (endPoint in endPoints)
            throw IllegalStateException("Endpoint $endPoint is already registered")*/
        endPoints.add(endPoint)
    }


    data class Context(
            val route: String,
            val privileges: MutableSet<AdminPrivilege>,
            val authentications: MutableSet<Authentication>,
            val interceptors: MutableSet<CallInterceptor>,
            ) {
        fun requireAny(vararg privilege: AdminPrivilege) = require(*privilege)
        fun require(vararg privilege: AdminPrivilege) {
            privileges.addAll(privilege)
            authentications.add(Authentication.JWT)
        }

        fun interceptor(vararg interceptor: CallInterceptor) {
            interceptors.addAll(interceptor)
        }

        fun requireAny() = auth(Authentication.JWT)

        fun auth(vararg auth: Authentication) {
            authentications.addAll(auth)
        }

        operator fun String.invoke(block: Context.() -> Unit) {
            val upperPath = this
            val upperContext = this@Context
            block(
                    Context(
                            "${upperContext.route}/$upperPath",
                            upperContext.privileges.toMutableSet(),
                            upperContext.authentications.toMutableSet(),
                            upperContext.interceptors.toMutableSet()
                    )
            )
        }

    }
}